"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    if (!element.value) {
        return '';
    }
    return (0, rich_text_1.slateToMarkdown)(element.value, {
        allowHtmlStyles: context.withStyle,
        allowAlignment: context.withStyle,
        allowCaptionHtml: context.withStyle,
    });
};
exports.toMarkdown = toMarkdown;
